import React, { useEffect, useCallback } from "react";

import FullPageLoader from "../FullPageLoader";

import * as authApi from "js/api/authApi";
import { LoginDelegatedRequest, LoginResponse } from "js/api/authApi";
import { useUserSessionStore } from "stores/v2/userSessionStore";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginProvider } from "js/api/loginApi";
const LoginClasslinkCallback: React.FC = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const handleLoginFailure = useCallback(
		(error: unknown): void => {
			const apiError = error as authApi.ApiError<authApi.LoginMethodError> | authApi.ApiError<authApi.ServerError>;
			useUserSessionStore.getState().handleAuthenticationFailure(apiError);

			if (apiError.respJson && "provider" in apiError.respJson) {
				navigate("/login", { state: { provider: apiError.respJson.provider } });
			} else {
				navigate("/login", { state: { error: "Classlink" } });
			}
		},
		[navigate]
	);

	useEffect(() => {
		const searchParams = new URLSearchParams(location.search);
		const loginRequest: LoginDelegatedRequest = {
			code: searchParams.get("code") || "",
			deviceid: searchParams.get("state") || "",
		};

		authApi
			.loginDelegated(LoginProvider.CLASSLINK, loginRequest)
			.then((res: LoginResponse) => {
				useUserSessionStore
					.getState()
					.handleAuthenticationSuccess(res)
					.then(() => navigate("/"))
					.catch(handleLoginFailure);
			})
			.catch(handleLoginFailure);
	}, [navigate, handleLoginFailure, location]);

	return <FullPageLoader message="Logging in with Classlink" />;
};

export default LoginClasslinkCallback;
